import { render } from "./MultipleChipSelection.vue?vue&type=template&id=f45b7752&scoped=true&ts=true"
import script from "./MultipleChipSelection.vue?vue&type=script&lang=ts"
export * from "./MultipleChipSelection.vue?vue&type=script&lang=ts"

import _style_0 from "./MultipleChipSelection.vue?vue&type=style&index=0&id=f45b7752&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-f45b7752"]])

export default __exports__